module.exports = __webpack_public_path__ + "static/media/navbarlogo.548f69bf.png";